export default {
  TOGGLE_LOADING(state, toggle) {
    state.loading = toggle;
  },

  SET_STATUS(state, { status, message, errorCode }) {
    state.status = status;
    state.message = message;
    state.errorCode = errorCode;
  },

  SET_NEXT_PAGE(state, nextPage) {
    state.nextPage = nextPage;
  },

  TOGGLE_MANAGE_MEMBERSHIP(state, toggle) {
    state.toggleManageMembership = toggle;
  },

};



// WEBPACK FOOTER //
// ./src/stores/Notification/mutations/index.js